import axios from 'axios';
import { BACKEND_URL, apiPath } from '../../../config/apiBase';

export { BACKEND_URL };
export const API = apiPath('/api/whatsapp-tasks');

export const BRIDGE_URL = process.env.REACT_APP_WHATSAPP_BRIDGE_URL || 'http://localhost:3001';

export function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    withCredentials: true,
    headers: { Authorization: `Bearer ${token}` },
  };
}

export const thStyle = { padding: '6px 8px', fontSize: '12px', fontWeight: '600', color: '#374151' };
export const tdStyle = { padding: '6px 8px', fontSize: '12px', color: '#111827' };

export const PRIORITY_STYLE = {
  high: { bg: '#FEE2E2', color: '#B91C1C', label: 'High' },
  medium: { bg: '#FEF3C7', color: '#92400E', label: 'Medium' },
  low: { bg: '#E0E7FF', color: '#3730A3', label: 'Low' },
};

export const STATUS_LABEL = {
  new: 'New',
  in_progress: 'In Progress',
  done: 'Done',
};

export async function fetchStats() {
  const res = await axios.get(`${API}/stats`, authHeaders());
  return res.data;
}

/** Fetch the WhatsApp linking QR via the backend proxy. Returns
 * { connected: bool, qr: <data-url|null> }. Going through the backend means the
 * browser never has to reach the bridge directly (which only worked on a local
 * dev machine where localhost:3001 pointed at the running bridge). */
export async function fetchBridgeQr() {
  const res = await axios.get(`${API}/bridge-qr`, authHeaders());
  return res.data;
}

/** Unlink WhatsApp — clears the bridge session; a new QR will be available to scan. */
export async function disconnectBridge() {
  const res = await axios.post(`${API}/bridge-disconnect`, {}, authHeaders());
  return res.data;
}

export async function fetchTasks(params = {}) {
  const res = await axios.get(`${API}/tasks`, { ...authHeaders(), params });
  return res.data;
}

export async function fetchTask(taskNo) {
  const res = await axios.get(`${API}/tasks/${taskNo}`, authHeaders());
  return res.data;
}

export async function updateTask(taskNo, patch) {
  const res = await axios.patch(`${API}/tasks/${taskNo}`, patch, authHeaders());
  return res.data;
}

export async function addNote(taskNo, text) {
  const res = await axios.post(`${API}/tasks/${taskNo}/notes`, { text }, authHeaders());
  return res.data;
}

export async function fetchAssignees() {
  const res = await axios.get(`${API}/assignees`, authHeaders());
  return res.data;
}

/** Attachments are auth-protected, so <img src> can't load them directly —
 * fetch as an authenticated blob and hand back an object URL instead. */
export async function fetchAttachmentBlob(relativeUrl) {
  const res = await axios.get(`${BACKEND_URL}${relativeUrl}`, { ...authHeaders(), responseType: 'blob' });
  return res.data;
}
